/**
 * Row actions (Start Call, Transfer Call, Park Call) appear on hover or focus.
 * While hidden they are taken out of flow and clipped, so they reserve no width
 * yet stay in the Tab order and accessibility tree; tabbing to one reveals it
 * through the row's :focus-within. The row must be `position: relative`.
 */
export const hiddenRowActionStyle = {
  position: 'absolute',
  top: 0,
  right: 0,
  clipPath: 'inset(50%)',
  opacity: 0,
  pointerEvents: 'none',
} as const

export const revealedRowActionStyle = {
  position: 'static',
  clipPath: 'none',
  opacity: 1,
  pointerEvents: 'auto',
} as const

export const rowActionRevealSelector = (className: string) =>
  `&:hover .${className}, &:focus-within .${className}`

/**
 * Like `rowActionRevealSelector`, but only keyboard focus reveals the actions,
 * so a mouse click doesn't leave them showing after the pointer leaves the row.
 */
export const rowActionKeyboardRevealSelector = (className: string) =>
  `&:hover .${className}, &:has(:focus-visible) .${className}`

/** Touch screens have no hover, so their row actions are always revealed. */
export const touchRowActionReveal = (className: string) => ({
  '@media (hover: none)': {
    [`& .${className}`]: revealedRowActionStyle,
  },
})
